document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('hlfOpOverlay');
  if (!overlay) return;

  // Move overlay to body to escape parent stacking contexts and z-index issues
  document.body.appendChild(overlay);

  const closeBtn = document.getElementById('hlfOpCloseBtn');
  const declineBtn = document.getElementById('hlfOpDeclineBtn');
  const delaySec = parseInt(overlay.getAttribute('data-delay') || '3', 10);
  
  // Check if we should show the popup
  const popupCookie = localStorage.getItem('hlfOfferPopupShown');
  if (popupCookie) {
    // return; // Uncomment to show only once
  }

  setTimeout(() => {
    overlay.classList.add('is-visible');
    localStorage.setItem('hlfOfferPopupShown', 'true');
    startTimer();
  }, delaySec * 1000);

  function closePopup() {
    overlay.classList.add('hiding');
    setTimeout(() => {
      overlay.classList.remove('is-visible', 'hiding');
    }, 220);
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (declineBtn) declineBtn.addEventListener('click', closePopup);

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closePopup();
  });

  /* -- copy -- */
  const copyBtn = document.getElementById('hlfOpCopyBtn');
  if (copyBtn) {
    copyBtn.addEventListener('click', () => {
      const codeDisplay = document.getElementById('hlfOpCodeDisplay');
      if (!codeDisplay) return;
      const code = codeDisplay.textContent.trim();
      const lbl = document.getElementById('hlfOpCopyLabel');

      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).catch(() => {});
      } else {
        const ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }

      copyBtn.classList.add('copied');
      lbl.textContent = 'Copied!';

      setTimeout(() => {
        copyBtn.classList.remove('copied');
        lbl.textContent = 'Copy code';
      }, 2400);
    });
  }

  /* -- countdown timer -- */
  let totalSecs = 14 * 60 + 59;
  let timerInterval;
  
  function startTimer() {
    if (timerInterval) return;
    const mmEl = document.getElementById('hlfOpMm');
    const ssEl = document.getElementById('hlfOpSs');
    if (!mmEl || !ssEl) return;

    timerInterval = setInterval(() => {
      if (totalSecs <= 0) {
        clearInterval(timerInterval);
        return;
      }
      totalSecs--;
      mmEl.textContent = String(Math.floor(totalSecs / 60)).padStart(2, '0');
      ssEl.textContent = String(totalSecs % 60).padStart(2, '0');
    }, 1000);
  }
});
